<template>
<div class="container" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
  <div class="comment" v-for="(item,index) in $store.state.comments" :key="index">
    <div class="commenter-line">
      <div class="nickName">{{item.createUserName}}</div>
      <div class="createTime"><timeago :datetime="item.createTime"></timeago></div>
    </div>
    <div class="content">{{item.content}}</div>
    <div class="replys">
      <div class="reply" v-for="(r,i) in item.replyVOS" :key="i">
        <span class="nickName">{{r.createUserName}}: </span>
        <span class="content">{{r.content}}</span>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import infiniteScroll from 'vue-infinite-scroll'
export default {
  directives: {infiniteScroll},
  methods:{
    loadMore(){
      console.log('load more')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  .comment {
    margin-top: 25px;
    padding: 0 22px;

    .commenter-line {
      display: flex;
      justify-content: space-between;

      .nickName {
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(128, 128, 128, 1);
        line-height: 26px;
      }

      .createTime {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(190, 190, 190, 1);
        line-height: 26px;
      }

    }

    .content {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(35, 24, 21, 1);
      line-height: 26px;
    }

    .replys {
      background: rgba(243, 243, 243, 1);
      border-radius: 7px;
      padding: 0px 15px;

      .reply {
        margin-top: 11px;

        .nickName {
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(128, 128, 128, 1);
          line-height: 26px;
        }

        .content {
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(35, 24, 21, 1);
          line-height: 26px;
        }
      }
    }
  }
}
</style>
